var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoAccessWt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.754,
    height: 30.184,
    viewBox: "0 0 22.754 30.184",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_929",
    "data-name": "Path 929",
    d: "M34.6,15.357h-.058V11.41a8.912,8.912,0,0,0-8.91-8.91h-.348a8.93,8.93,0,0,0-8.185,6.617,1.958,1.958,0,0,0,1.916,2.467,1.924,1.924,0,0,0,1.829-1.422,5.028,5.028,0,0,1,4.353-3.715c.174,0,.319-.029.464-.029a4.992,4.992,0,0,1,4.992,4.992v3.976H16.543a2.341,2.341,0,0,0-2.351,2.351v12.6a2.341,2.341,0,0,0,2.351,2.351H34.6a2.341,2.341,0,0,0,2.351-2.351V17.708A2.36,2.36,0,0,0,34.6,15.357ZM27.311,26.763a.436.436,0,0,1-.435.522H24.234a.436.436,0,0,1-.435-.522l.493-2.5a1.952,1.952,0,0,1-.668-1.8,2,2,0,0,1,1.712-1.625h.232A1.941,1.941,0,0,1,26.788,24.3Z",
    transform: "translate(-14.192 -2.5)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAccessWt);
export default __webpack_public_path__ + "static/media/ico_access_wt.3591bfbe4dc8e216b23d5570232acfe1.svg";
export { ForwardRef as ReactComponent };